<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20px"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="miter"
  >
    <path d="M12 2.5 22.7 21H1.3L12 2.5Z" />
    <path d="M12 9.5v4.2" />
    <path d="M12 17.3h.01" />
  </svg>
</template>
